export class DateRangeSearchModel
{
    public start_date: Date;
    public end_date: Date;
}

